import { IApiClientOptions } from 'core';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import { ManifestPlatformDto } from 'dto/raptor-component-version.dto';
import { transform } from 'dto/transformer';

export class RaptorManifestPlatformsApiClient extends AssureBaseApiClient {
    constructor(options: IApiClientOptions) {
        super('raptorManifestPlatforms', options);
    }

    protected getRootPath(): string {
        return 'raptor/manifest-platforms';
    }

    public async listManifestPlatforms(accountId: number): Promise<ManifestPlatformDto[]> {
        const response = await this.send<{ manifestPlatforms: ManifestPlatformDto[] }>(
            HTTP_METHOD.GET,
            this.getRequestOptionsWithAccountId(accountId, ''),
        );
        return transform(ManifestPlatformDto, response.manifestPlatforms || []);
    }
}
